import { HttpClient } from './httpClient'
import * as ApiEvents from './apiEvents'
import { showToast } from '../util/showToast'
import { setErrorMessage } from '../actions'
import store from '../store'

export const saveEvent = (eventMessage) => ({
  eventType: ApiEvents.SAVE_FORM_NL,
  eventTime: Date.now(),
  eventMessage,
})
const saveItemEvent = (eventMessage) => ({
  eventType: ApiEvents.SAVE_C88_ITEM,
  eventTime: Date.now(),
  eventMessage,
})

export const createInvoiceItems = (intentExportValue) => {
  let dataSent = saveEvent({
    shipmentId: { id: 'KX-J2J1-3960' },
    intentExport: { value: intentExportValue },
    header: {
      invoices: {
        invoices: [
          {
            invoiceId: '',
          },
        ],
      },
    },
  })

  return HttpClient.post(dataSent)
    .then((resp) => resp)
    .catch((error) => {
      console.error(`Error in delete deleteMerchandiseInfo : `, error)
    })
}
export const createMerchandiseItems = (invoiceID, intentExportValue) => {
  let dataSent = saveEvent({
    shipmentId: { id: 'KX-J2J1-3960' },
    intentExport: { value: intentExportValue },
    header: {
      invoices: {
        invoices: [
          {
            invoiceId: invoiceID,
            lineItems: [
              {
                merchandiseId: '',
                invoiceId: invoiceID,
                shipmentId: 'KX-J2J1-3960',
              },
            ],
          },
        ],
      },
    },
  })

  return HttpClient.post(dataSent)
    .then((resp) => resp)
    .catch((error) => {
      console.error(`Error in delete deleteMerchandiseInfo : `, error)
    })
}

const bulkUpdateEvent = (eventMessage) => ({
  eventType: 'BULK_SAVE_C88_ITEMS',
  eventTime: Date.now(),
  eventMessage,
})
export const deleteDan = () => {
  let dataSent = saveEvent({
    shipmentId: window.shipmentId,
    deferredAccount2: '_BLANK_',
    deferredAccountType2: '_BLANK_',
  })

  return HttpClient.post(dataSent).catch((error) => {
    console.error(`Error in delete deleteMerchandiseInfo : `, error)
  })
}

export const removeContainerNumber = (merchandiseId, value) => {
  let dataSent = saveItemEvent({
    descriptionOfMerchandise: {
      merchandiseLineItems: [
        {
          merchandiseId,
          containerNumbers: {
            value: value,
          },
        },
      ],
    },
    shipmentId: window.shipmentId,
  })

  return HttpPostRequest(dataSent)
}

export const HttpPostRequest = (requestParams, fieldName = '') => {
  return HttpClient.post(requestParams)
    .then((res) => {
      if (
        fieldName !== 'procedure' &&
        res.data.eventMessage.code !== 200 &&
        res.data.eventMessage.hasOwnProperty('code') === true
      ) {
        console.error(
          'errorCode :' + res.data.eventMessage.code,
          'eventMessage :' + res.data.eventMessage.msg
        )
        console.log('eventMessage :' + res.data.eventMessage.msg)
        store.dispatch(setErrorMessage('Data not saved, try again after sometime!'))
        showToast('Data not saved, try again after sometime!')
      } else {
        //   store.dispatch(setErrorMessage("Data saved successfully."))
        //  showToast("Data saved successfully.");
        res = res.data.eventMessage
      }

      return res
    })
    .catch((error) => {
      console.log('ERROR:: ' + error)
      showToast('Something went wrong, Check your network connection!')
      return ''
    })
}

export const saveShipmentDetail = (fieldName, value) => {
  let dataSent = saveEvent({
    [fieldName]: value,
    shipmentId: window.shipmentId,
  })

  return HttpPostRequest(dataSent)
}

export const saveShipmentDuty = (fieldName, value, dutyExtUkId) => {
  let dataSent = saveEvent({
    shipmentId: window.shipmentId,
    valueBuildUp: {
      [fieldName]: value,
      dutyExtUkId,
      shipmentId: window.shipmentId,
    },
  })

  return HttpPostRequest(dataSent)
}

export const bulkUpdate = (syncAdjustmentCode, adjustmentCode) => {
  let datasent = bulkUpdateEvent({
    shipmentId: window.shipmentId,
    syncAdjustmentCode,
    adjustmentCode,
  })

  return datasent
}

export const saveMerchandiseLineItem = (merchandiseId, fieldName, value, merchandise, eta) => {
  let dataSent = {}
  if (fieldName === 'commodityCode' && merchandise.countryOfOrigin !== '') {
    dataSent = saveItemEvent({
      descriptionOfMerchandise: {
        merchandiseLineItems: [
          {
            merchandiseId,
            [fieldName]: value,
            countryOfOrigin: merchandise.countryOfOrigin,
          },
        ],
      },
      shipmentId: window.shipmentId,
      eta,
    })
  } else if (
    fieldName === 'countryOfOrigin' &&
    merchandise.commodityCode.replace(/\./g, '') !== ''
  ) {
    dataSent = saveItemEvent({
      descriptionOfMerchandise: {
        merchandiseLineItems: [
          {
            merchandiseId,
            [fieldName]: value,
            commodityCode: merchandise.commodityCode.replace(/\./g, ''),
          },
        ],
      },
      shipmentId: window.shipmentId,
      eta,
    })
  } else {
    dataSent = saveItemEvent({
      descriptionOfMerchandise: {
        merchandiseLineItems: [
          {
            merchandiseId,
            [fieldName]: value,
          },
        ],
      },
      shipmentId: window.shipmentId,
      eta,
    })
  }

  return HttpPostRequest(dataSent, fieldName)
}

export const saveInvoiceItem = (invoiceId, fieldName, value) => {
  let dataSent = saveEvent({
    invoices: [
      {
        invoiceId,
        [fieldName]: value,
        shipmentId: window.shipmentId,
      },
    ],

    shipmentId: window.shipmentId,
  })

  return HttpPostRequest(dataSent)
}

export const saveNotes = (noteId, fieldName, value) => {
  let dataSent = {
    eventType: ApiEvents.SAVE_SHIPMENT_NOTES,
    eventTime: Date.now(),
    eventMessage: {
      noteId,
      [fieldName]: value,
      shipmentId: window.shipmentId,
    },
  }

  return HttpPostRequest(dataSent)
}

export const addMerchandiseLineItem = (invoiceId, declarationTypeValue) => {
  let dataSent = saveItemEvent({
    shipmentId: window.shipmentId,
    descriptionOfMerchandise: {
      merchandiseLineItems: [
        {
          invoiceId: invoiceId,
        },
      ],
    },
    declarationType: declarationTypeValue,
  })

  return dataSent
}
export const createInvoice = (declarationTypeValue) => {
  let dataSent = saveEvent({
    invoices: [{ invoiceId: '', shipmentId: window.shipmentId }],
    declarationType: declarationTypeValue,
    shipmentId: window.shipmentId,
  })
  return dataSent
}

export const saveMerchandiseLineItemDuty = (
  merchandiseId,
  merchandiseDutyId,
  fieldName,
  value,
  fieldName2 = '',
  value2 = ''
) => {
  let dataSent = {}
  if (fieldName2 !== '' && value2 !== '') {
    dataSent = saveItemEvent({
      descriptionOfMerchandise: {
        merchandiseLineItems: [
          {
            merchandiseId,
            C88MerchandiseDuty: [
              {
                [fieldName]: value,
                [fieldName2]: value2,
                merchandiseId,
                merchandiseDutyId,
              },
            ],
          },
        ],
      },
      shipmentId: window.shipmentId,
    })
  } else {
    dataSent = saveItemEvent({
      descriptionOfMerchandise: {
        merchandiseLineItems: [
          {
            merchandiseId,
            C88MerchandiseDuty: [
              {
                [fieldName]: value,
                merchandiseId,
                merchandiseDutyId,
              },
            ],
          },
        ],
      },
      shipmentId: window.shipmentId,
    })
  }

  return HttpPostRequest(dataSent)
}

export const saveAdditonalInfo = (infoId, fieldName, value) => {
  let dataSent = saveEvent({
    additionalInfos: [
      {
        [fieldName]: value,
        infoId: infoId,
        shipmentId: window.shipmentId,
      },
    ],
    shipmentId: window.shipmentId,
  })

  return HttpPostRequest(dataSent)
}

export const saveAIStatementAndCodesInfo = (infoId, fieldName, value) => {
  let dataSent = saveEvent({
    aiStatementUkInfo: [
      {
        [fieldName]: value,
        infoId: infoId,
        shipmentId: window.shipmentId,
      },
    ],
    shipmentId: window.shipmentId,
  })

  return HttpPostRequest(dataSent)
}

export const saveLineItemInfo = (merchandiseId, infoId, fieldName, value) => {
  let dataSent = saveItemEvent({
    descriptionOfMerchandise: {
      merchandiseLineItems: [
        {
          merchandiseId,
          additionalInfo: [
            {
              [fieldName]: value,
              merchandiseId,
              infoId,
              shipmentId: window.shipmentId,
            },
          ],
        },
      ],
    },
    shipmentId: window.shipmentId,
  })

  return HttpPostRequest(dataSent)
}

export const saveLineItemAIInfo = (merchandiseId, infoId, fieldName, value) => {
  let dataSent = saveItemEvent({
    descriptionOfMerchandise: {
      merchandiseLineItems: [
        {
          merchandiseId,
          aiStatementUkInfo: [
            {
              [fieldName]: value,
              merchandiseId,
              infoId,
              shipmentId: window.shipmentId,
            },
          ],
        },
      ],
    },
    shipmentId: window.shipmentId,
  })

  return HttpPostRequest(dataSent)
}

export const saveLineItemSummaryInfo = (merchandiseId, infoId, fieldName, value) => {
  let dataSent = saveItemEvent({
    descriptionOfMerchandise: {
      merchandiseLineItems: [
        {
          merchandiseId,
          previousDocumentInfo: [
            {
              [fieldName]: value,
              merchandiseId,
              infoId,
              shipmentId: window.shipmentId,
            },
          ],
        },
      ],
    },
    shipmentId: window.shipmentId,
  })

  return HttpPostRequest(dataSent)
}

export const addMerchandiseLineItemDuty = (merchandiseId) => {
  let dataSent = saveItemEvent({
    descriptionOfMerchandise: {
      merchandiseLineItems: [
        {
          merchandiseId,
          C88MerchandiseDuty: [{}],
        },
      ],
    },
    shipmentId: window.shipmentId,
  })

  return dataSent
}

export const addNotesItem = (description, createdBy, hotCheckBox) => {
  let dataSent = {
    eventType: ApiEvents.SAVE_SHIPMENT_NOTES,
    eventTime: Date.now(),
    eventMessage: {
      shipmentId: window.shipmentId,
      status: '0',
      description,
      hot: hotCheckBox === true ? '1' : '0',
      userName: createdBy,
      dateOfNote: { epochs: new Date().getTime() },
    },
  }

  return dataSent
}

export const addLineItemAddInfo = (merchandiseId) => {
  let dataSent = saveItemEvent({
    descriptionOfMerchandise: {
      merchandiseLineItems: [
        {
          merchandiseId,
          additionalInfo: [{ merchandiseId, infoId: '', shipmentId: window.shipmentId }],
        },
      ],
    },
    shipmentId: window.shipmentId,
  })

  return dataSent
}

export const addAddInfo = () => {
  let dataSent = saveEvent({
    additionalInfos: [
      {
        shipmentId: window.shipmentId,
        infoId: '',
      },
    ],
    shipmentId: window.shipmentId,
  })

  return dataSent
}

export const addAIInfo = () => {
  let dataSent = saveEvent({
    aiStatementUkInfo: [
      {
        shipmentId: window.shipmentId,
        infoId: '',
      },
    ],
    shipmentId: window.shipmentId,
  })

  return dataSent
}

export const addAIInfoLineItem = (merchandiseId) => {
  let dataSent = saveItemEvent({
    descriptionOfMerchandise: {
      merchandiseLineItems: [
        {
          merchandiseId,
          aiStatementUkInfo: [{ merchandiseId, infoId: '', shipmentId: window.shipmentId }],
        },
      ],
    },
    shipmentId: window.shipmentId,
  })

  return dataSent
}

export const addMerchandiseLineItemSummary = (merchandiseId) => {
  let dataSent = saveItemEvent({
    descriptionOfMerchandise: {
      merchandiseLineItems: [
        {
          merchandiseId,
          previousDocumentInfo: [{ merchandiseId, infoId: '', shipmentId: window.shipmentId }],
        },
      ],
    },
    shipmentId: window.shipmentId,
  })

  return dataSent
}

export const saveActorDetail = (actorType, fieldName, id, value) => {
  let dataSent = saveEvent({
    [actorType]: {
      id,
      [fieldName]: value,
    },
    shipmentId: window.shipmentId,
  })

  return HttpPostRequest(dataSent)
}

export const saveActorAddress = (actorType, id, address) => {
  let dataSent = saveEvent({
    [actorType]: {
      id,
      addressInfo: buildRequestAddress(address),
    },
    shipmentId: window.shipmentId,
  })

  return HttpPostRequest(dataSent)
}

const buildRequestAddress = (storeAddress) => {
  if (!storeAddress) return []
  let addressInfo = []
  for (let type in storeAddress) {
    if (type === 'STREET_NAME') {
      let splitStreet = storeAddress[type].split(' ')
      if (parseInt(splitStreet[0])) {
        addressInfo.push({
          type: 'STREET_NUMBER',
          information: splitStreet[0],
        })
        addressInfo.push({
          type: 'STREET_NAME',
          information: splitStreet.slice(1).join(' '),
        })
      } else {
        addressInfo.push({
          type: 'STREET_NUMBER',
          information: '',
        })
        addressInfo.push({
          type: 'STREET_NAME',
          information: splitStreet.join(' '),
        })
      }
    } else {
      addressInfo.push({
        type: type,
        information: storeAddress[type],
      })
    }
  }
  return addressInfo
}
